import * as React from 'react';
import classNames from 'classnames';
import './styles.scss';

export interface ICTABlockProps {
    image?: React.ReactNode;
    link?: string;
    className?: string;
}

const CTABlock: React.FunctionComponent<ICTABlockProps> = (props) => {
    return (
        <div className="cta-block">
            {props.image && (
              <div className="cta-block__image">
                  {props.link ? (
                    <a href={props.link}>{props.image}</a>
                  ) : props.image}
              </div>
            )}
            {props.children && (
              <div className={classNames('cta-block__text', props.className)}>
                  <div className="cta-block__text-inner">
                      {props.children}
                  </div>
              </div>
            )}
        </div>
    );
};

CTABlock.displayName = 'CTABlock';

export default CTABlock;
